<template>
  <div>
    <Head title="Edit Block" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/blocks/uncut">Uncut Blocks</Link>
      <span class="text-orange-400 font-medium">/</span> {{ block.name }}/Edit
    </h1>
    <div class="bg-white rounded-md shadow">
        <form @submit.prevent="update">
            <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pl-8 pr-8 pb-8">
                <div class="w-full lg:w-full">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-4 pr-6 w-full lg:w-4/4" label="Name" />
                </div>
                <div class="pb-4 pr-6 w-full lg:w-4/4">
                    <label class="form-label" for="block-type">Block Type:</label>
                    <multiselect
                        id="block_type_id"
                        v-model="selectedBlockType"
                        placeholder="Search Block Types"
                        :options="types"
                        :close-on-select="true"
                        :searchable="true"
                        :error="form.errors.block_type_id"
                        :style="form.errors.block_type_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                        @search-change="onSearchBlockTypeChange"
                        @input="onSelectedBlockType"
                    />
                    <div v-if="form.errors.block_type_id" class="form-error">{{ form.errors.block_type_id }}</div>
                </div>
                <div class="w-full lg:w-full">
                    <text-input v-model="form.dimension" :error="form.errors.dimension" class="pb-4 pr-6 w-full lg:w-4/4" label="Dimension" />
                </div>
                <div class="fw-full lg:w-full">
                    <text-input v-model="form.weight" :error="form.errors.weight" class="pb-4 pr-6 w-full lg:w-4/4" label="Weight" />
                </div>
                <div
                class="flex items-center justify-end w-full px-8 py-4 bg-gray-50 border-t border-gray-100"
                >
                    <loading-button :loading="form.processing" class="btn-orange px-3 py-2 text-xs" type="submit">
                        Update
                    </loading-button>
                </div>
            </div>
       </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import Multiselect from '@vueform/multiselect'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    TextInput,
    Multiselect,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  props: {
    block: Object,
    categories: Object,
    types: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.block.name,
        block_type_id: this.block.block_type_id,
        weight: this.block.weight,
        dimension: this.block.dimension,
      }),
      selectedBlockType: this.block.block_type_id,
    }
  },
  methods: {
    update() {
      this.form.post(`/blocks/${this.block.id}`, {
        onSuccess: () => {
          this.form.reset(
            'name',
            'weight',
            'deminsion',
          )
        }
      })
    },
    onSelectedBlockType(block_type_id, id) {
       this.form.block_type_id = block_type_id
       this.selectedBlockType = block_type_id
    },
    onSearchBlockTypeChange: throttle(function (block_type_id) {
        this.form.block_type_id = block_type_id
        this.selectedBlockType = block_type_id
    }, 200),
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
